import { FormControl, IconButton, InputAdornment, InputLabel, MenuItem, Select, TextField } from "@material-ui/core";
import ClearIcon from "@material-ui/icons/Clear";
import React, { useMemo, useState } from "react";
import { useTranslate } from "react-admin";

import { InfoBox } from "./InfoBox";

interface SearchableSelectProps {
  label: string;
  labelId: string;
  value: string;
  options: string[];
  onChange: (value: string) => void;
  disabled?: boolean;
  placeholder?: string;
}

export const SearchableSelect: React.FC<SearchableSelectProps> = ({
  label,
  labelId,
  value,
  options,
  onChange,
  disabled = false,
  placeholder,
}) => {
  const translate = useTranslate();
  const resolvedPlaceholder = placeholder || translate('osfc.storage_ui.search.placeholder_default');
  const [search, setSearch] = useState("");

  // Filter options based on search
  const filteredOptions = useMemo(() => {
    return options.filter(option =>
      option.toLowerCase().includes(search.toLowerCase())
    );
  }, [options, search]);

  const handleChange = (newValue: string) => {
    onChange(newValue);
  };

  const handleClear = (e: React.MouseEvent) => {
    e.stopPropagation();
    onChange("");
  };

  return (
    <FormControl fullWidth variant="outlined" size="small" disabled={disabled}>
      <InputLabel id={labelId}>{label}</InputLabel>
      <Select
        labelId={labelId}
        value={value}
        onChange={(e) => handleChange(e.target.value as string)}
        onClose={() => setTimeout(() => setSearch(""), 150)}
        label={label}
        endAdornment={
          value && !disabled && (
            <InputAdornment position="end" style={{ marginRight: '8px' }}>
              <IconButton
                size="small"
                onClick={handleClear}
              >
                <ClearIcon fontSize="small" />
              </IconButton>
            </InputAdornment>
          )
        }
        MenuProps={{
          PaperProps: {
            style: {
              maxHeight: 300,
            },
          },
        }}
      >
        <div style={{ padding: "8px 16px", position: "sticky", top: 0, backgroundColor: "white", zIndex: 1 }}>
          <TextField
            fullWidth
            size="small"
            placeholder={resolvedPlaceholder}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            onClick={(e) => e.stopPropagation()}
            onKeyDown={(e) => e.stopPropagation()}
          />
        </div>
        {filteredOptions.map((option) => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};